import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, description, action }: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3 md:mb-6">
      <div className="min-w-0">
        {eyebrow && (
          <p className="mb-1 flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-accent-700">
            <span className="h-3 w-0.5 rounded-full bg-accent-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {description && <p className="mt-1.5 text-xs text-foreground-500 md:text-sm">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}